module.exports = __webpack_public_path__ + "img/frame (114).9681665a.jpg";